<template>
  <div id="info">
    <CCard>
      <CCardHeader>
        <h2>勤務表（管理者用）</h2>
      </CCardHeader>
      <CCardHeader>
        <strong>{{ user_name }}</strong>
      </CCardHeader>
    </CCard>
    <Roster
      :externalUserId="Number($route.params.user_id)"
      :externalYear="Number($route.params.year)"
      :externalMonth="Number($route.params.month)"
      :externalUserName="String($route.params.user_name)"
      :fromExternal="true"
    />
  </div>
</template>

<script>
import Roster from '../../report/Roster';

export default {
  name: 'Info',
  components: {
    Roster
  },
  data() {
    return {
      user_id: '',
      user_name: '',
      year: null,
      month: null
    };
  },
  mounted() {
    this.user_id = this.$route.params.user_id;
    this.year = Number(this.$route.params.year);
    this.month = Number(this.$route.params.month);
    this.user_name = this.$route.params.user_name;
  }
};
</script>

<style scoped>
button:disabled {
  cursor: not-allowed;
}
</style>
